import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/critter";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="读者最常问的几个问题"
          desc="关于可信度、内容边界与投稿方式，这里一次性说清楚。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-accent-400" : "border-background-300"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-3 font-heading text-[15px] font-bold leading-snug text-foreground-950">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 font-label text-xs font-bold text-accent-800">
                      {i + 1}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-accent-600 transition-transform ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}